import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function NigeriaLanguagePage() {
    return (
        <Box sx={{ padding: "2rem", background: "#f9fafb", maxWidth: "900px", margin: "auto" }}>
            <Typography variant="h4" sx={{ fontWeight: "700", color: "#09122C", mb: 2 }}>
                Yoruba & English Language Training – Nigeria Focus
            </Typography>

            <Typography variant="body1" sx={{ lineHeight: 1.8, color: "#374151", mb: 2 }}>
                Explore our specialized programs in Yoruba and English designed for professionals and students across Nigeria. Whether you're looking to improve communication, prepare for international exams, or engage with local heritage — we’ve got certified trainers ready to help.
            </Typography>

            <ul style={{ lineHeight: "1.8", color: "#374151" }}>
                <li>IELTS & TOEFL preparation (English)</li>
                <li>Professional workplace English (health, business, tech)</li>
                <li>Cultural Yoruba classes for diaspora learners</li>
                <li>Language access for study or work relocation</li>
            </ul>

            <Button
                variant="contained"
                sx={{ mt: 3, backgroundColor: "#065f46", "&:hover": { backgroundColor: "#09122C" } }}
                href="/#"
            >
                View Nigeria Language Programs
            </Button>
        </Box>
    );
}
